export default "__VITE_ASSET__e3e3e534__"